module.exports = __webpack_public_path__ + "static/media/Illustration_point4.ad20a16f.svg";